import React, { Component } from 'react';
import { getPlayerId } from '../utils/playerId';

const fetch = require("node-fetch");

class ShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '', status: 'idle', error_message: '' };
    this.handle_change = this.handle_change.bind(this);
    this.handle_submit = this.handle_submit.bind(this);
    this.handle_key_down = this.handle_key_down.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handle_key_down);
    if (this.email_input) {
      this.email_input.focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handle_key_down);
  }

  handle_key_down(event) {
    if (event.key === 'Escape') {
      this.props.onClose();
    }
  }

  handle_change(event) {
    this.setState({ email: event.target.value });
  }

  async handle_submit(event) {
    event.preventDefault();
    this.setState({ status: 'sending', error_message: '' });
    try {
      const api_url = this.props.apiUrl || '/api/share_joke';
      const payload = this.props.payload || { joke: this.props.jokeId };
      const response = await fetch(api_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, email: this.state.email, player: getPlayerId() }),
      });
      const json = await response.json();
      if (!response.ok) {
        this.setState({ status: 'error', error_message: json.error || 'Something went wrong' });
        return;
      }
      this.setState({ status: 'sent' });
    } catch (error) {
      this.setState({ status: 'error', error_message: 'Could not reach the server' });
    }
  }

  render() {
    return (
      <div
        id="share_modal_overlay"
        onClick={(event) => { if (event.target === event.currentTarget) this.props.onClose(); }}
      >
        <div role="dialog" aria-modal="true" aria-labelledby="share_modal_title" id="share_modal">
          <h2 id="share_modal_title">{this.props.title || 'Share this joke'}</h2>
          <button
            id="share_modal_close"
            type="button"
            aria-label="Close"
            onClick={() => this.props.onClose()}
          >×</button>
          {this.state.status === 'sent' ? (
            <p id="share_modal_success">Sent! 🎉</p>
          ) : (
            <form onSubmit={this.handle_submit}>
              <label htmlFor="share_email_input">{this.props.recipientLabel || 'Send this joke to:'}</label>
              <input
                id="share_email_input"
                type="email"
                required
                placeholder="friend@example.com"
                value={this.state.email}
                onChange={this.handle_change}
                ref={ref => this.email_input = ref}
              />
              <button id="share_submit" type="submit" disabled={this.state.status === 'sending'}>
                {this.state.status === 'sending' ? 'Sending…' : 'Send'}
              </button>
              {this.state.status === 'error' && (
                <p id="share_modal_error" role="alert">{this.state.error_message}</p>
              )}
            </form>
          )}
        </div>
      </div>
    );
  }
}

export default ShareModal;
